import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-coding-duration-report-dw",
  templateUrl: "./coding-duration-report-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CodingDurationReportDwComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.CODING_DURATION_REPORT_DW;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID2, HideFilters.ORG_ID, HideFilters.PROJECT_NAME2];
}
